import { FloatingSubmenuProps } from '../menuTypes'
import { MenuColumn } from './MenuColumn'

export function FloatingSubmenu({
  data,
  top,
  onEnter,
  onLeave,
}: FloatingSubmenuProps) {
  return (
    <div
      className='absolute left-0 w-screen px-6 grid grid-cols-3 gap-6 z-50 bg-white shadow-inset-top-f4'
      style={{ top }}
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
    >
      {data.map((col, i) => (
        <MenuColumn key={i} rows={col} />
      ))}
    </div>
  )
}
